import { useSessionSharingPolicy } from '@heidi/workspace';

/**
 * Returns whether direct session sharing is allowed for the current user's org or
 * standalone team. See `useSessionSharingPolicy` for the resolution order.
 */
export function useIsDirectSessionSharingAllowed(): boolean {
  return useSessionSharingPolicy().isDirectSharingAllowed;
}
